import React                                                     from 'react';
import { ENVIRONMENT_IS_DEVELOPMENT, ENVIRONMENT_IS_PRODUCTION } from '../constants/SystemEnums';
import { CORVAL_USERSNAP_API, USERSNAP_API_NAMES }               from '../views/components/util/external/UserSnapForm';

interface useUserSnapToolsHook {
	
	invokeUserSnap(): void,
	
	invokeInternalUserSnap(): void
	
	invokeProductionUserSnap(): void
	
	hasUserSnap(): boolean,
	
	hasInternalUserSnapInstalled(): boolean
	
	hasProductionUserSnapInstalled(): boolean
}

export const getInstance = () => {
	
	return window[ 'userpilot' ] ?? undefined;
}

const invokeInternalUserSnap = () => {
	
	window[ `${ CORVAL_USERSNAP_API }-${ USERSNAP_API_NAMES.TEST_BUG_REPORT }` ].open()
}

const invokeProductionUserSnap = () => {
	
	window[ `${ CORVAL_USERSNAP_API }-${ USERSNAP_API_NAMES.PROD_BUG_REPORT }` ].open()
}

const hasInternalUserSnapInstalled = () => {
	
	return !!( window[ `${ CORVAL_USERSNAP_API }-${ USERSNAP_API_NAMES.TEST_BUG_REPORT }` ] )
}

const hasProductionUserSnapInstalled = () => {
	
	return !!( window[ `${ CORVAL_USERSNAP_API }-${ USERSNAP_API_NAMES.PROD_BUG_REPORT }` ] )
}

const invokeUserSnap = () => {
	
	try{
		
		if( !ENVIRONMENT_IS_PRODUCTION ) invokeInternalUserSnap();
		if( ENVIRONMENT_IS_PRODUCTION ) invokeProductionUserSnap();
		
	} catch( e ) {
		
		_alertNoInstanceAvailable()
	}
	
}

const hasUserSnap = () => {
	
	try{
		
		if( !ENVIRONMENT_IS_PRODUCTION ) return hasInternalUserSnapInstalled();
		if( ENVIRONMENT_IS_PRODUCTION ) return hasProductionUserSnapInstalled();
		
	} catch( e ) {
		
		_alertNoInstanceAvailable()
	}
	
}

const _alertNoInstanceAvailable = () => alert( `Sorry, this feature is not available right now. Contact Corval Support for further assistance.` );

export const useUserSnapTools = (): useUserSnapToolsHook => {
	
	return {
		invokeUserSnap,
		hasUserSnap,
		invokeInternalUserSnap,
		invokeProductionUserSnap,
		hasInternalUserSnapInstalled,
		hasProductionUserSnapInstalled,
	}
};
